'use strict';

/*global blockElement*/
/*global unBlockElement*/
/*global services*/
/*global getPosition*/
/*global validateInputs*/
/*global compareDates*/
/*global incDate*/
/*global formatDate*/
/*global strToDate*/
/*global isEmpty*/
/*global initialize*/

function CatalogFilter(containerID) {
    this.containerID = containerID;
    this.$container = null;
    this.$form = null;
    this.$formWrapper = null;
    this.$contentWrapper = null;
    this.$basketItemsWrapper = null;

    this.lastAmount = null;

    this.searchTimeout = null;
    this.searchDelayTime = 500; //ms
    this.loadAmountTimeout = null;
    this.loadAmountDelayTime = 500; //ms

    this.init();
}

CatalogFilter.prototype = $.extend({}, {
    construtor: 'CatalogFilter',

    //**************************************************************************

    registerCallbacks: function registerCallbacks() {
        var _this = this;

        _this.$form.off('submit');
        _this.$form.on('submit', function submitFormClb() {
            _this.searchItems(true);

            return false;
        });

        _this.$form.off('click', 'button:submit');
        _this.$form.on('click', 'button:submit', function submitFormClb() {
            _this.updateSelectedVariantByBtn($(this));
            if (_this.preValidateFrom()) {
                _this.doItemsSearch();
            }

            return false;
        });

        _this.$form.off('click', 'button:reset');
        _this.$form.on('click', 'button:reset', function resetFormClb() {
            _this.searchItems();
        });

        _this.$form.off('change', 'input:not(:radio,:checkbox), select, textarea');
        _this.$form.on('change', 'input:not(:radio,:checkbox), select, textarea', function changeFormItemClb() {
            if ($(this).data('prev_val') !== $(this).val()) {
                $(this).data('prev_val', $(this).val());
                _this.searchItems();
            }
        });

        _this.$form.off('change', 'input:radio, input:checkbox');
        _this.$form.on('change', 'input:radio, input:checkbox', function changeFormItemClb() {
            _this.searchItems();
        });

        _this.$form.find('input, textarea').off('keyup');
        _this.$form.find('input, textarea').on('keyup', function keyUpFormItemClb() {
            if ($(this).data('prev_val') !== $(this).val()) {
                $(this).data('prev_val', $(this).val());
                _this.searchItems();
            }
        });

        _this.$form.off('keyup change', 'input[name$="filter_amount"]');
        _this.$form.on('keyup change', 'input[name$="filter_amount"]', function changeAmountClb() {
            if (_this.lastAmount !== $(this).val()) {
                _this.lastAmount = $(this).val();
                _this.changeAmount();
            }
        });

        _this.$contentWrapper.off('click', '.load-next-items');
        _this.$contentWrapper.on('click', '.load-next-items', function loadNextItemsClb() {
            _this.loadNextItems($(this));

            return false;
        });

        _this.$contentWrapper.off('click', '.pagination a');
        _this.$contentWrapper.on('click', '.pagination a', function clickPaginationClb() {
            if (!$(this).hasClass('disabled')) {
                _this.doItemsSearch($(this).data('index'));
            }

            return false;
        });

        _this.$form.off('click', '.connector-btn');
        _this.$form.on('click', '.connector-btn', function toggleRoomsClb() {
            _this.toggleRooms($(this));

            return false;
        });

        _this.$form.off('click', '.catalog-filter-item-new');
        _this.$form.on('click', '.catalog-filter-item-new', function catalogFilterItemNew() {
            _this.newCatalogFilterItem();

            return false;
        });

        return _this;
    },

    getFilterValues: function getFilterValues() {
        var _this = this;

        return _this.$form.serializeObject();
    },

    updateSelectedVariantByBtn: function updateSelectedVariantByBtn($btn) {
        var _this = this;

        if (_this.$form.find('input[name$="filter_selected_variant"]').val() === $btn.val()) {
            _this.$form.find('input[name$="filter_selected_variant"]').val('');
            $btn.removeClass('btn-success');
        } else {
            _this.$form.find('input[name$="filter_selected_variant"]').val($btn.val());
            _this.$form.find('button[name$="filter_variant"].btn-success').removeClass('btn-success');
            $btn.addClass('btn-success');
        }
    },

    newCatalogFilterItem: function newCatalogFilterItem() {
        var _this = this;

        blockElement(_this.$form);
        $.postCORS(services.get('configurations').param('DomainURL') + '/?action=catalog&method=js_new_catalog_filter_item', _this.$form.serialize(), function newCatalogFilterItemClb(res) {
            unBlockElement(_this.$form);

            try {
                res = JSON.parse(res);
                if(res.msg === 'SUCCESS') {
                    _this.$formWrapper.replaceWith(res.data.html);
                    _this.init();
                    _this.loadCatalogFilterBasketItems();
                } else {
                    services.get('development').viewSiteErrorMsg(res);
                }
            } catch(e) {
                services.get('development').viewSiteErrorMsg(res, e);
            }
        });

        return _this;
    },

    changeAmount: function changeAmount() {
        var _this = this;

        clearTimeout(_this.loadAmountTimeout);

        var $amount = _this.$form.find('input[name$="filter_amount"]');
        if(validateInputs($amount, ['integer', 'not_empty'])) {
            _this.loadAmountTimeout = setTimeout(function loadAmountTimeout() {
                var $amountWrapper = _this.$form.find('.form-items-amounts');

                blockElement($amountWrapper);
                $.postCORS(services.get('configurations').param('DomainURL') + '/?action=catalog&method=js_get_amount_form', _this.$form.serialize(), function getAmountFormClb(res) {
                    unBlockElement($amountWrapper);
                    try {
                        res = JSON.parse(res);
                        if(res.msg === 'SUCCESS') {
                            $amountWrapper.html(res.data.html);
                            _this.$form.find('input:radio:checked:first').change();
                        } else {
                            services.get('development').viewSiteErrorMsg(res);
                        }
                    } catch(e) {
                        services.get('development').viewSiteErrorMsg(res, e);
                    }
                });
            }, _this.loadAmountDelayTime);
        }

        return _this;
    },

    toggleRooms: function toggleRooms($btn) {
        var _this = this;

        var $wrapper = $btn.closest('.connector-wrapper');
        var $input = $wrapper.find('input:checkbox');

        $input.prop('checked', !$input.prop('checked')).change();

        return _this;
    },

    setFilterDateFrom: function setFilterDateFrom(date) {
        var _this = this;

        _this.$form.find('input[name$="filter_date_from"]').val(date).change();
        if (services.get('configurations').param('MultiDaysReservation') && services.get('configurations').param('ReservationWithouLastDay')) {
            _this.$form.find('input[name$="filter_date_to"]').val(formatDate(incDate(strToDate(date)))).change();
        }

        return _this;
    },

    setFilterParam: function setFilterParam(paramID, valueID) {
        var _this = this;

        _this.$form.find('.form-group[data-param_id="' + paramID + '"]').find('input, select, textarea').val(valueID).change();

        return _this;
    },

    clearFilterDate: function clearFilterDate() {
        var _this = this;

        _this.$form.find('input[name$="filter_date_from"]').val('').change();
        _this.$form.find('input[name$="filter_date_to"]').val('').change();

        return _this;
    },

    clearFilterParams: function clearFilterParams() {
        var _this = this;

        _this.$form.find('.form-group[data-param_id]').find('input, select, textarea').val('').change();

        return _this;
    },

    preValidateFrom: function preValidateFrom() {
        var _this = this;

        //zvalidujeme zadane datumy
        var $date = _this.$form.find('input[name$="filter_date_from"]');
        validateInputs($date, ['date', 'not_empty']);

        $date = _this.$form.find('input[name$="filter_date_to"]');
        validateInputs($date, ['date', services.get('configurations').param('MultiDaysRequired') ? 'not_empty' : '']);

        if (services.get('configurations').param('ReservationType') === 'CAPACITY') {
            //zvalidujeme mnozstvi
            var $amount = _this.$form.find('input[name$="filter_amount"]');
            validateInputs($amount, ['integer', 'not_empty']);

            _this.$form.find('.catalog-filter-amount-row').each(function () {
                var $tr = $(this);

                $tr.removeClass('has-error');
                if ($tr.find('input:radio:checked').length === 0) {
                    $tr.addClass('has-error');
                }
            });

            if (services.get('configurations').param('MultiDaysReservation')) {
                var $dateFrom = _this.$form.find('input[name$="filter_date_from"]');
                var $dateTo = _this.$form.find('input[name$="filter_date_to"]');
                var $dateToFormGroup = $dateTo.closest('.form-group');

                if (!isEmpty($dateFrom.val()) && !isEmpty($dateTo.val()) && compareDates($dateFrom.val(), $dateTo.val()) >= 0) {
                    $dateToFormGroup.addClass('has-error');
                }

                if (services.get('configurations').param('ReservationWithouLastDay')) {
                    if (!$dateToFormGroup.hasClass('has-error')) {
                        if(compareDates($dateFrom.val(), $dateTo.val()) === 0) {
                            $dateToFormGroup.addClass('has-error');
                        }
                    }
                }
            }
        }

        return _this.$form.find('.has-error').length === 0;
    },

    searchItems: function searchItems(forceSearch) {
        var _this = this;

        clearTimeout(_this.searchTimeout);

        if (_this.preValidateFrom()) {
            if(forceSearch) {
                _this.loadInfoPanel();
                _this.doItemsSearch();
            } else {
                $('#catalog-date-shift-msg').hide();      

                _this.searchTimeout = setTimeout(function searchItemsTimeout() {
                    _this.loadInfoPanel();
                    _this.doItemsSearch();
                }, _this.searchDelayTime);
            }
        }

        return _this;
    },

    doItemsSearch: function doItemsSearch(index) {
        var _this = this;

        var variant = _this.$form.find('input[name$="filter_selected_variant"]').val();

        blockElement(_this.$contentWrapper);
        $.postCORS(services.get('configurations').param('DomainURL') + '/?action=catalog&method=js_items_search' + (index ? '&index=' + index : '') + (variant ? '&variant=' + variant : ''), _this.$form.serialize(), function doItemsSearchClb(res) {
            unBlockElement(_this.$contentWrapper);
            try {
                res = JSON.parse(res);
                if(res.msg === 'SUCCESS') {
                    _this.$contentWrapper.html(res.data.html);

                    initialize(_this.$contentWrapper);
                } else {
                    services.get('development').viewSiteErrorMsg(res);
                }
            } catch(e) {
                services.get('development').viewSiteErrorMsg(res, e);
            }
        });

        return _this;
    },

    loadInfoPanel: function loadInfoPanel() {
        var _this = this;

        var $dateFrom = _this.$form.find('input[name$="filter_date_from"]');
        if(validateInputs($dateFrom, ['date', 'not_empty'])) {
            if (services.has('catalogInfoPanel')) {
                services.get('catalogInfoPanel').loadInfoPanel(_this.$form);
            }
        }

        return _this;
    },

    loadNextItems: function loadNextItems($btn) {
        var _this = this;

        var $loadNextItemsWrapper = _this.$contentWrapper.find('.load-next-items-wrapper');

        blockElement($btn);
        $.postCORS(services.get('configurations').param('DomainURL') + '/?action=catalog&method=js_load_next_items&index=' + $loadNextItemsWrapper.data('next_index'), _this.$form.serialize(), function loadNextItemsClb(res) {
            unBlockElement($btn);
            try {
                res = JSON.parse(res);
                if(res.msg === 'SUCCESS') {
                    _this.$contentWrapper.find('.items-wrapper').append(res.data.html);
                    _this.$contentWrapper.find('.pagitation-wrapper').html(res.data.pagitation);

                    initialize(_this.$contentWrapper);

                    if(res.data.last_index) {
                        $loadNextItemsWrapper.hide();
                    } else {
                        $loadNextItemsWrapper.data('next_index', res.data.next_index);
                    }
                } else {
                    services.get('development').viewSiteErrorMsg(res);
                }
            } catch(e) {
                services.get('development').viewSiteErrorMsg(res, e);
            }
        });

        return _this;
    },

    loadCatalogFilterBasketItems: function loadCatalogFilterBasketItems() {
        var _this = this;

        if (services.has('catalogFilterBasketItems')) {
            services.get('catalogFilterBasketItems').loadCatalogFilterBasketItems();
        }

        return _this;
    },

    loadCatalogFilter: function loadCatalogFilter(catalogFilterItemId) {
        var _this = this;

        blockElement(_this.$form);
        $.getCORS(services.get('configurations').param('DomainURL') + '/?action=catalog&method=js_load_catalog_filter&catalog_filter_item_id=' + catalogFilterItemId, function loadCatalogFilterClb(res) {
            unBlockElement(_this.$form);
            try {
                res = JSON.parse(res);
                if(res.msg === 'SUCCESS') {
                    _this.$formWrapper.replaceWith(res.data.html);
                    _this.init();
                } else {
                    services.get('development').viewSiteErrorMsg(res);
                }
            } catch(e) {
                services.get('development').viewSiteErrorMsg(res, e);
            }
        });

        return _this;
    },

    //**************************************************************************

    init: function init() {
        var _this = this;

        _this.$container = $('#' + _this.containerID);
        _this.$form = _this.$container.find('.catalog-filter-form');
        _this.$formWrapper = _this.$container.find('.catalog-filter');
        _this.$contentWrapper = _this.$container.find('.catalog-content');
        _this.$basketItemsWrapper = _this.$container.find('.catalog-filter-basket-items');

        _this.registerCallbacks();
        _this.doItemsSearch();

        return _this;
    }
});
